import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import { DataDictionaryMentionItem } from '../../atoms';
import { Button, Text, Pluralize } from '../../../../../components';

const DataDictionaryModalFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid var(--border-muted);
  min-height: 60px;
`;

const ModalFooterButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const SelectedColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  transition: gap 0.3s ease-in-out;
  gap: ${(props) => (props.$gap ? '12px' : '0')};
`;

const DataDictionaryMentionItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
`;

const DataDictionaryModalFooter = ({
  close,
  handleAddTableMentions,
  onDelete,
  selectedItems = []
}) => (
  <DataDictionaryModalFooterContainer>
    <SelectedColumnsContainer $gap={selectedItems.length > 0}>
      {selectedItems.length > 0 ? (
        <Text $color='var(--content-subtitle)'>
          Selected
          <Pluralize word='field' count={selectedItems.length} showCount={false} />
        </Text>
      ) : (
        <CSSTransition in appear timeout={300} classNames='gap-transition'>
          <Text $color='var(--content-subtitle)'>Select the field(s) to add to your question.</Text>
        </CSSTransition>
      )}
      <DataDictionaryMentionItemContainer>
        {selectedItems.map((item) => (
          <DataDictionaryMentionItem key={item.value} item={item} onDelete={onDelete} />
        ))}
      </DataDictionaryMentionItemContainer>
    </SelectedColumnsContainer>

    <ModalFooterButtonGroup>
      <Button naked onClick={close}>
        Cancel
      </Button>
      <Button
        primary
        onClick={() => {
          handleAddTableMentions(close);
        }}
      >
        Add to prompt
      </Button>
    </ModalFooterButtonGroup>
  </DataDictionaryModalFooterContainer>
);

DataDictionaryModalFooter.propTypes = {
  close: PropTypes.func.isRequired,
  handleAddTableMentions: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      table: PropTypes.string,
      tags: PropTypes.string
    })
  )
};

export { DataDictionaryModalFooter };
